// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A node's header, on the canvas and in a notebook cell: the title at the left,
   after Play, and its pills right after it. */
.k5Mss_tSu1IStmpdL51Z {
    flex: 0 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    font-family: var(--curio-font-family);
}

.jIEOKQ8BumOZ68itnDpA {
    flex: 0 1 auto;
    min-width: 0;
    text-align: left;
    font-size: var(--curio-font-size-sm, 13px);
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--curio-text-secondary);
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font-family: inherit;
    cursor: pointer;
}

.tCa19KCBA_NPkmG3e6C4 {
    cursor: pointer;
    border-radius: var(--curio-radius-sm);
}

.tCa19KCBA_NPkmG3e6C4:hover {
    background: rgba(30, 31, 35, 0.06);
    color: var(--curio-text-primary);
}

.aiS0R8J1xcoPFVidwIa_ {
    color: var(--curio-text-on-dark);
}

.hnzvWoVVGQfBQXdEG8Q6 {
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: var(--curio-font-size-sm);
    font-weight: 700;
    color: var(--curio-text-primary);
    border: 1px solid var(--curio-top-bar-bg);
    border-radius: var(--curio-radius-sm);
    padding: 2px 6px;
    background: var(--curio-card-bg);
    font-family: inherit;
    box-sizing: border-box;
}

.hnzvWoVVGQfBQXdEG8Q6:focus {
    outline: none;
}

.LNT4UTH3qOxlAfwrmEOj {
    color: var(--curio-text-on-dark);
    background: rgba(30, 31, 35, 0.85);
    border-color: var(--curio-text-on-dark);
}

.g3wNSKQfEoKTMnKUtqJG {
    color: var(--curio-role-installed-fg);
    margin-right: 2px;
    font-size: 10px;
    flex-shrink: 0;
}

.hsXz0yxDNsp2AixzyZz6 {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-sm);
    background: transparent;
    color: var(--curio-text-secondary);
    cursor: pointer;
    font-size: var(--curio-font-size-xs);
    line-height: 1;
}

.hsXz0yxDNsp2AixzyZz6:hover {
    border-color: var(--curio-text-primary);
    color: var(--curio-text-primary);
    background: rgba(30, 31, 35, 0.04);
}

.egC_wZyQnNRMMVW0w4b8 {
    border-color: rgba(255, 255, 255, 0.35);
    color: var(--curio-text-on-dark);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/editing/EditableNodeHeaderLabel.module.css"],"names":[],"mappings":"AAAA;8CAC8C;AAC9C;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,gCAAgC;IAChC,yCAAyC;IACzC,qCAAqC;IACrC,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,4CAA4C;IAC5C,qCAAqC;IACrC,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;IACf,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;AACpC","sourcesContent":["/* A node's header, on the canvas and in a notebook cell: the title at the left,\n   after Play, and its pills right after it. */\n.labelWrap {\n    flex: 0 1 auto;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n    font-family: var(--curio-font-family);\n}\n\n.labelText {\n    flex: 0 1 auto;\n    min-width: 0;\n    text-align: left;\n    font-size: var(--curio-font-size-sm, 13px);\n    font-weight: 700;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--curio-text-secondary);\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    cursor: pointer;\n}\n\n.labelTextEditable {\n    cursor: pointer;\n    border-radius: var(--curio-radius-sm);\n}\n\n.labelTextEditable:hover {\n    background: rgba(30, 31, 35, 0.06);\n    color: var(--curio-text-primary);\n}\n\n.labelTextHighlighted {\n    color: var(--curio-text-on-dark);\n}\n\n.labelInput {\n    flex: 1;\n    min-width: 0;\n    text-align: center;\n    font-size: var(--curio-font-size-sm);\n    font-weight: 700;\n    color: var(--curio-text-primary);\n    border: 1px solid var(--curio-top-bar-bg);\n    border-radius: var(--curio-radius-sm);\n    padding: 2px 6px;\n    background: var(--curio-card-bg);\n    font-family: inherit;\n    box-sizing: border-box;\n}\n\n.labelInput:focus {\n    outline: none;\n}\n\n.labelInputHighlighted {\n    color: var(--curio-text-on-dark);\n    background: rgba(30, 31, 35, 0.85);\n    border-color: var(--curio-text-on-dark);\n}\n\n.execMark {\n    color: var(--curio-role-installed-fg);\n    margin-right: 2px;\n    font-size: 10px;\n    flex-shrink: 0;\n}\n\n.configBtn {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    padding: 0;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-sm);\n    background: transparent;\n    color: var(--curio-text-secondary);\n    cursor: pointer;\n    font-size: var(--curio-font-size-xs);\n    line-height: 1;\n}\n\n.configBtn:hover {\n    border-color: var(--curio-text-primary);\n    color: var(--curio-text-primary);\n    background: rgba(30, 31, 35, 0.04);\n}\n\n.configBtnHighlighted {\n    border-color: rgba(255, 255, 255, 0.35);\n    color: var(--curio-text-on-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelWrap": `k5Mss_tSu1IStmpdL51Z`,
	"labelText": `jIEOKQ8BumOZ68itnDpA`,
	"labelTextEditable": `tCa19KCBA_NPkmG3e6C4`,
	"labelTextHighlighted": `aiS0R8J1xcoPFVidwIa_`,
	"labelInput": `hnzvWoVVGQfBQXdEG8Q6`,
	"labelInputHighlighted": `LNT4UTH3qOxlAfwrmEOj`,
	"execMark": `g3wNSKQfEoKTMnKUtqJG`,
	"configBtn": `hsXz0yxDNsp2AixzyZz6`,
	"configBtnHighlighted": `egC_wZyQnNRMMVW0w4b8`
};
export default ___CSS_LOADER_EXPORT___;
